import app from "../../app";

export function submit({commit}, error) {
  commit('push', error);
}

export function graphqlSubmit({dispatch, commit, rootState}, {error, operation, uri}) {
  //if (app.env.NODE_ENV === 'development') {
  let errorMessage = `GraphQL Error:`
    + (operation ? ` (${operation.operationName})` : '');

  errorMessage += '\n\nURI:\n' + uri;

  if (rootState?.tokenData?.username){
    errorMessage += '\n\nUSER:\n' + rootState.tokenData.username;
  }

  if (error.message){
    errorMessage += '\n\nMESSAGE:\n' + error.message;
  }

  if (operation) {
    errorMessage += '\n\nQUERY:\n' + operation.query?.loc?.source?.body;
    errorMessage += '\n\nVARIABLES:\n' + JSON.stringify(operation.variables);

    const context = operation.getContext();

    if (context && context.headers){
      errorMessage += '\n\nHEADERS:\n' + JSON.stringify(context.headers);
    }
  }

  errorMessage += '\n\nFRONTEND TRACE:\n' + (new Error()).stack;

  if (error.trace) {
    let traceString = '\n\nBACKEND TRACE:\n';
    error.trace.forEach(trace => {
      if (trace.file) {
        traceString += 'file: ' + trace.file + '\n';
      }
      if (trace.call) {
        traceString += 'call: ' + trace.call + '\n';
      }

      traceString += '\n';
    })

    errorMessage += traceString;
  }

  if (error.message === 'validation'){
    console.warn(errorMessage);
    console.warn({error, operation});
  }else{
    console.error(errorMessage);
    console.error({error, operation});
  }

  //}

  // dispatch('error/submit', error, {root: true});
}

export function graphqlDebug({dispatch, commit, rootState}, {operation, uri}) {
  let debugMessage = `GraphQL Debug:`
    + (operation ? ` (${operation.operationName})` : '');

  debugMessage += '\n\nURI:\n' + uri;

  if (rootState?.tokenData?.username){
    debugMessage += '\n\nUSER:\n' + rootState.tokenData.username;
  }

  if (operation) {
    debugMessage += '\n\nQUERY:\n' + operation.query?.loc?.source?.body;
    debugMessage += '\n\nVARIABLES:\n' + JSON.stringify(operation.variables);

    const context = operation.getContext();

    if (context && context.headers){
      debugMessage += '\n\nHEADERS:\n' + JSON.stringify(context.headers);
    }
  }

  console.info(debugMessage);
}
